import {styled} from "@mui/material/styles";
import {ButtonGroup, Grid, Typography, TypographyProps} from "@mui/material";

export const CustomerTextGrid = styled(Grid)(({theme}) => ({
  alignItems: "flex-start",
  gap: 50,
  marginTop: 20,
  marginLeft: "4.3rem",
  marginRight: "4.3rem",
  [theme.breakpoints.down('sm')]: {
    marginLeft: '1rem',
    marginRight: '1rem',
  },
}));

export const CustomerTextFlex = styled('div')(() => ({
  display: "flex",
  gap: "20px",
  minWidth: 0,
  '& > div': {
    minWidth: 0,
    flex: 1,
  },
}));

export const CustomerTextHead = styled(Typography)(() => ({
  fontSize: 20,
  fontWeight: "700",
  marginBottom: 10,
  overflowWrap: 'break-word',
}));

export const CustomerTextP = styled(Typography)<TypographyProps>(() => ({
  fontSize: 16,
  maxWidth: 315,
  overflowWrap: 'break-word',
}));

export const HowItWorksSection = styled('section')(() => ({
  justifyContent: 'center',
  marginTop: 70,
  backgroundColor: "#FFFFFF",
  paddingTop: 30,
  paddingBottom: 30,
  borderBottom: "0.4rem solid #757DE8"
}));

export const HowItWorksHeader = styled('header')(() => ({
  justifyContent: 'center',
  textAlign: 'center',
  height: '1%',
  fontSize: 32
}));

export const HowItWorksH3 = styled(Typography)<TypographyProps>(() => ({
  textAlign: 'center'
}));

export const HowItWorksOverLine = styled(Typography)<TypographyProps>(() => ({
  textAlign: 'center',
  fontSize: 12,
}));

export const HowItWorksButtonGroup = styled(ButtonGroup)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: '3%',
  marginBottom: 48
}));

export const PartnerTextGrid = styled(Grid)(({theme}) => ({
  alignItems: "flex-start",
  gap: 50,
  marginTop: 20,
  marginLeft: "4.3rem",
  marginRight: "4.3rem",
  [theme.breakpoints.down('sm')]: {
    marginLeft: '1rem',
    marginRight: '1rem',
  },
}));
